<template>
	<ConfirmationDialog
		v-if="isOpen"
		:header="header"
		:description="description"
		:actions="actions"
	/>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ConfirmationDialog } from "@teaming/common-ui";

export default {
	name: "AppConfirmationDialogHOC",

	components: {
		ConfirmationDialog,
	},

	props: {},

	computed: {
		...mapGetters( "host-dialogs", [
			"isConfirmationDialogOpen",
			"options",
		] ),
		actions() {
			return this.options.actions.map( a => {
				return {
					...a,
					label: this.$t( a.label, this.options.metadata ),
					onButtonPress: () => {
						a.onButtonPress();
						this.toggleConfirmationDialog( { isOpen: false, } );
					},
				};
			} );
		},
		header() {
			return this.options?.header && this.$t( this.options.header, this.options.metadata );
		},
		description() {
			return this.options?.description && this.$t( this.options.description, this.options.metadata );
		},
		isOpen: {
			get() {
				return this.isConfirmationDialogOpen;
			},
			set( isOpen ) {
				this.toggleConfirmationDialog( isOpen );
			},
		},
	},
	watch: {},
	methods: {
		...mapMutations( "host-dialogs", [
			"toggleConfirmationDialog",
		] ),
	},
};
</script>
